import React, { FC } from 'react';
import { ReactComponent as Instagram } from '../../../assets/SocialMedia/Instagram.svg';

export const InstagramIcon: FC = () => <Instagram />;
